/**
 * Feature flags for temporary or conditional behaviour.
 * Set to false to re-enable normal payment gating.
 */
export const FREE_ACCESS_MODE = true;
